import { render, staticRenderFns } from "./teacherEdit-pc.vue?vue&type=template&id=c5917bf2&scoped=true&"
import script from "./teacherEdit-pc.vue?vue&type=script&lang=js&"
export * from "./teacherEdit-pc.vue?vue&type=script&lang=js&"
import style0 from "./teacherEdit-pc.vue?vue&type=style&index=0&id=c5917bf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5917bf2",
  null
  
)

export default component.exports